import { v4 as uuidv4 } from 'uuid';
import { IBox, IBoxRole } from '@app/store/modules/boxes/types';
import { INavItem } from './types';
import { Path, Section } from '@app/const/paths';
import { Direction } from '@app/const/consts';
import { IUserFilter } from '@services/userFilters/types';
import { getUserFilterUrl } from '@utils/userFilters';

export const ACTION_REQUIRED_ROUTE_FOLDER = 'tasks';

export const getActionRequiredRoute = (boxOguid: string): string =>
  `${Section.ENVELOPES_BOX_OGUID.replace(':boxOguid', boxOguid)}/${ACTION_REQUIRED_ROUTE_FOLDER}`;

const getUserFilterMenuItems = (
  route: string,
  userFilters: IUserFilter[]
): INavItem[] =>
  userFilters
    .filter((filter) => filter.route === route)
    .map((filter) => ({
      hasPage: true,
      iconProps: { classes: 'mr-4' },
      isFavoriteFilter: true,
      route: getUserFilterUrl(filter),
      title: filter.title,
      uuid: filter.oguid,
    }));

// Добавление ящиков в меню
export const addBoxMenuItems = (
  menuItems: INavItem[],
  boxes: IBox[],
  userFilters: IUserFilter[] = [],
  actionRequiredCounts: Record<string, number> = {}
) => {
  let newMenuItems = [...menuItems];
  if (boxes.length) {
    const boxItems: INavItem[] = boxes
      .filter((val) => !val.isPersonal)
      .map((val): INavItem => {
        const items: INavItem[] = [
          {
            iconProps: { classes: 'mr-4' },
            route: Path.ENVELOPES_BOX_SETTINGS.replace(':boxOguid', val.oguid),
            title: 'boxes:settings.general.menu',
            uuid: uuidv4(),
            // menuLevel: LibNavItemLevel.LOW,
          },
        ];

        if (val.role !== IBoxRole.MANAGER) {
          items.push(
            {
              iconProps: { classes: 'mr-4' },
              route: Path.ENVELOPES_BOX_USERS.replace(
                ':boxOguid',
                val.oguid
              ),
              title: 'boxes:users.title',
              uuid: uuidv4(),
              // level: LibNavItemLevel.LOW,
            },
            {
              iconProps: { classes: 'mr-4' },
              route: Path.ENVELOPES_BOX_SUBDIVISIONS.replace(
                ':boxOguid',
                val.oguid
              ),
              title: 'boxes:settings.subdivisions.menu',
              uuid: uuidv4(),
            },
            {
              iconProps: { classes: 'mr-4' },
              route: Path.ENVELOPES_BOX_CUSTOM_FIELDS.replace(
                ':boxOguid',
                val.oguid
              ),
              title: 'boxes:settings.customFields.menu',
              uuid: uuidv4(),
            },
            {
              iconProps: { classes: 'mr-4' },
              route: Path.ENVELOPES_BOX_LABELS.replace(':boxOguid', val.oguid),
              title: 'boxes:settings.labels.menu',
              uuid: uuidv4(),
            },
            {
              iconProps: { classes: 'mr-4' },
              route: Path.ENVELOPES_BOX_ENVELOPE_TEMPLATES.replace(
                ':boxOguid',
                val.oguid
              ),
              title: 'boxes:settings.envelopeTemplates.menu',
              uuid: uuidv4(),
            }
          );
        }

        const adminPanel: INavItem[] = [
          {
            hasPage: false,
            icon: 'IconCog',
            iconProps: { classes: 'mr-2' },
            route: Section.ENVELOPES_BOX_SETTINGS.replace(
              ':boxOguid',
              val.oguid
            ),
            title: 'boxes:settings.title',
            uuid: uuidv4(),
            // menuLevel: LibNavItemLevel.TOP,
            items: items,
          },
        ];

        const contactDirectoryItems: INavItem[] =
          val.role === IBoxRole.VIEWER
            ? []
            : [
                {
                  icon: 'IconUsers',
                  iconProps: { classes: 'mr-2' },
                  route: Path.ENVELOPES_BOX_CONTACT_DIRECTORY.replace(
                    ':boxOguid',
                    val.oguid
                  ),
                  title: 'boxes:settings.contactDirectory.menu',
                  uuid: uuidv4(),
                },
              ];

        const incomingRoute = Path.ENVELOPES_BOX_OGUID.replace(
          ':boxOguid',
          val.oguid
        ).replace(':directionOrFolder', Direction.INCOMING);
        const outgoingRoute = Path.ENVELOPES_BOX_OGUID.replace(
          ':boxOguid',
          val.oguid
        ).replace(':directionOrFolder', Direction.OUTGOING);

        const boxMenuItems: INavItem[] = [
          {
            badge: {
              name: String(actionRequiredCounts[val.oguid] ?? 0),
              path: '',
              theme: 'primary',
            },
            icon: 'IconChecklist',
            iconProps: { classes: 'mr-2' },
            route: getActionRequiredRoute(val.oguid),
            title: 'envelopes:myTasks',
            uuid: uuidv4(),
          },
          {
            icon: 'IconIncomingAlt',
            iconProps: { classes: 'mr-2' },
            route: incomingRoute,
            title: 'envelopes:incoming',
            uuid: uuidv4(),
          },
          ...getUserFilterMenuItems(incomingRoute, userFilters),
          {
            icon: 'IconOutgoingAlt',
            iconProps: { classes: 'mr-2' },
            route: outgoingRoute,
            title: 'envelopes:outgoing',
            uuid: uuidv4(),
          },
          ...getUserFilterMenuItems(outgoingRoute, userFilters),
          ...contactDirectoryItems,
          ...(val.role === IBoxRole.ADMIN ? adminPanel : []),
        ];

        return {
          contentData: {
            content: val.email,
            heading: val.companyName,
          },
          hasPage: false,
          iconCollapse: 'IconAngle',
          iconCollapseProps: { classes: 'ml-auto icon-collapse', size: 'xs' },
          items: boxMenuItems,
          route: Section.ENVELOPES_BOX_OGUID.replace(':boxOguid', val.oguid),
          title: val.companyName,
          uuid: uuidv4(),
        };
      });

    newMenuItems = [...newMenuItems, ...boxItems];
  }

  return newMenuItems;
};
